import React from "react";
import Foundation from "@microsoft/fast-components-foundation-react";
import { classNames } from "@microsoft/fast-web-utilities";
export const canvasStyleSheet = {
    canvas: {
        flex: "1",
        overflow: "hidden",
    },
};
/**
 * Grid Canvas - this is the main content area of the grid.
 */
export class Canvas extends Foundation {
    constructor() {
        super(...arguments);
        /**
         * Handled prop enumeration
         */
        this.handledProps = {
            minWidth: void 0,
            managedClasses: void 0,
        };
    }
    /**
     * Generate the style attribute object
     */
    renderStyleAttribute() {
        return {
            minWidth: `${this.props.minWidth}px`,
        };
    }
    /**
     * Render the Canvas
     */
    render() {
        return (React.createElement("div", Object.assign({}, this.unhandledProps(), { className: super.generateClassNames(classNames(this.props.managedClasses.canvas)), "data-grid-app": "canvas", style: this.renderStyleAttribute() }), this.props.children));
    }
}
Canvas.displayName = "Canvas";
/**
 * Default props for the Canvas component
 */
Canvas.defaultProps = {
    managedClasses: {},
    minWidth: 300,
};
export * from "./canvas.props";
